import React from "react";

import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./SupportAssistant.module.css";

type ConfirmNewConversationProps = Readonly<{ onConfirm: () => void; onCancel: () => void }>;

/** Inline confirm shown before the current conversation is replaced (FR-029d). */
export const ConfirmNewConversation: React.FC<ConfirmNewConversationProps> = ({
  onConfirm,
  onCancel,
}) => {
  const [message, confirm, cancel] = useStrings(
    "supportAssistant_newConversationConfirm",
    "supportAssistant_confirmContinue",
    "supportAssistant_cancel"
  );
  return (
    <div className={styles.confirm} role="alertdialog" aria-label={message}>
      <span>{message}</span>
      <button
        type="button"
        className={styles.textButton}
        onClick={onConfirm}
        data-testid="support-assistant-confirm"
      >
        {confirm}
      </button>
      <button type="button" className={styles.textButton} onClick={onCancel}>
        {cancel}
      </button>
    </div>
  );
};
